export default __webpack_public_path__ + "d2fc6b4b37b2ac1585fe4959777d8321.svg";